import './App.css';
import Home from './pages/homepage/home';
import Login from './pages/loginpage/Login'; 
import ViewProduct from './components/footer/product/ViewProduct';
import { BrowserRouter, Route, Routes } from 'react-router-dom'; 
import { AuthProvider } from './context/AuthContext'; 

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <BrowserRouter>
          <AuthProvider> {/* ✅ Wrap all routes with AuthProvider */}
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/home" element={<Home />} />
              <Route path="/view/:id" element={<ViewProduct />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </header>
    </div>
  );
}

export default App;



